import { requestOptions, BASE_URL } from '../constants';

export const getSingleStory = async slug => {
	try {
		const response = await fetch(`${BASE_URL}/stories/inr/view/${slug}/`, requestOptions);
		if (!response.ok) return null;
		const data = await response.json();
		return data;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Always invokes the callback, even on network/parse errors, so consumers
// can settle their loading state instead of getting stuck.
const fetchListWithCallback = async (url, callback) => {
	try {
		const response = await fetch(url, requestOptions);
		if (!response.ok) {
			console.error(`${url} returned HTTP ${response.status}`);
			callback({ results: [] });
			return;
		}
		const result = await response.json();
		callback(result);
	} catch (error) {
		console.error(`${url} failed:`, error);
		callback({ results: [] });
	}
};

export const getStoriesVideo = callback =>
	fetchListWithCallback(`${BASE_URL}/stories/inr/list/?type=portrait&order=random`, callback);

export const getStoriesPodcast = callback =>
	fetchListWithCallback(`${BASE_URL}/stories/inr/list/?type=podcast&order=random`, callback);

export const getStoriesReview = callback =>
	fetchListWithCallback(`${BASE_URL}/stories/inr/list/?type=review&order=random`, callback);

export const getStories = async () => {
	try {
		const response = await fetch(`${BASE_URL}/stories/inr/list/?order=random`, requestOptions);
		const result = await response.json();
		return result.results;
	} catch (error) {
		console.log(error);
		return null;
	}
};
